/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.sessions

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import studio.oddpods.cauce.core.base.ui.EventsEffect
import studio.oddpods.cauce.core.ui.scaffold.KptScaffold
import studio.oddpods.cauce.feature.sessions.generated.resources.Res
import studio.oddpods.cauce.feature.sessions.generated.resources.sessions_form_title

@Composable
fun LogSessionScreen(
    onBackClick: () -> Unit,
    modifier: Modifier = Modifier,
    preselectedPatientId: String? = null,
    viewModel: LogSessionViewModel = koinViewModel(),
) {
    val state by viewModel.stateFlow.collectAsStateWithLifecycle()

    LaunchedEffect(preselectedPatientId, state.isLoadingPatients) {
        if (preselectedPatientId != null && !state.isLoadingPatients && state.selectedPatientId == null) {
            viewModel.trySendAction(LogSessionAction.PatientSelected(preselectedPatientId))
        }
    }

    EventsEffect(eventFlow = viewModel.eventFlow) { event ->
        when (event) {
            LogSessionEvent.SaveSuccess -> onBackClick()
        }
    }

    KptScaffold(
        onNavigationIconClick = onBackClick,
        title = stringResource(Res.string.sessions_form_title),
        modifier = modifier,
    ) {
        SessionFormContent(
            state = state,
            onAction = { viewModel.trySendAction(it) },
            dateFormatter = viewModel.dateFormatter,
            modifier = Modifier
                .fillMaxSize()
                .padding(horizontal = 16.dp),
        )
    }
}
